import React from 'react';
import styled from 'styled-components/macro';

interface ITextLink {
  label: string;
}

interface ITextLinkAnchor extends ITextLink {
  tag: 'a';
  href: string;
  target?: string;
}

interface ITextLinkButton extends ITextLink {
  tag: 'button';
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

type Props = ITextLinkAnchor | ITextLinkButton;

const StyledTextLink = styled.div`
  color: inherit;
`;

export const TextLink: React.FC<Props> = (props) => {
  switch (props.tag) {
    case 'a':
      return (
        <StyledTextLink
          as={props.tag}
          href={props.href}
          target={props.target ?? '_self'}
          rel={props.target ?? 'noopener'}
        >
          {props.label}
        </StyledTextLink>
      );
    case 'button':
      return <StyledTextLink as={props.tag} onClick={props.onClick}>{props.label}</StyledTextLink>;
    default:
      throw new Error('This is not a valid tag for TextLink');
  }
};